module.exports = __webpack_public_path__ + "img/passport-icon.9e247fd6.svg";